var _circle, _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgClose = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.00018,
    cy: 8.50006,
    r: 7.15789,
    fill: "#890A0A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7313 11.9655C11.9065 12.141 11.6445 12.4092 11.4661 12.2306L7.99995 8.76483L4.53378 12.2306C4.35612 12.4083 4.09322 12.1409 4.26861 11.9655L7.73478 8.49969L4.26861 5.0339C4.09209 4.8572 4.35726 4.59224 4.53378 4.76875L7.99995 8.23455L11.4661 4.76875C11.6428 4.59224 11.9076 4.8572 11.7313 5.0339L8.26512 8.49969L11.7313 11.9655Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.842105
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClose, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/close.4dc76ebb.svg";
export { ForwardRef as ReactComponent };